import MaskedNumberInput, { MaskedNumberInputProps } from 'components/masked-number-input';

import { toPercent } from 'lib/utils';

type PercentInputProps = MaskedNumberInputProps;

const PercentInput: React.FC<PercentInputProps> = (props) => {
  return <MaskedNumberInput min={-100} max={500} sign='%' format={toPercent} {...props} />;
};

export default PercentInput;
